import React from 'react';
  import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,  
    DialogContentText,
    DialogActions,
    Button,
    Divider
  } from '@mui/material';
  import { styled } from '@mui/material/styles';
  import  { tableCellClasses } from '@mui/material/TableCell';
import { useEffect,useState} from 'react';
import { toast } from 'react-toastify';
import { GetUser_ForDashboard,GetSingleUser,EditUser } from '../../Services/Authservices';
import moment from 'moment/moment';
import SpinnerModal from '../../Spinner/SpinnerModal';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import Slide from '@mui/material/Slide';
import Stack from '@mui/material/Stack';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import './UserManagement.css';
import '../../UI/Common.css'
import SignUp from '../SignUp';

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2c6bd7',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      backgroundColor: '#ffffff',
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nStyledTableCell-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child StyledTableCell, &:last-child StyledTableCell': {
      border: 0,
    },
  }));

  const Transition = React.forwardRef(function Transition(props, ref) {
    const transitionDuration = 500; // milliseconds
    return <Slide direction="down" ref={ref} {...props} timeout={transitionDuration} />;
  });
  
  const UserLists = () =>{
    const[userDetails,SetuserDetails] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [UserID, setUserd] = useState();

    const openModal = () => {
        setModalIsOpen(true);
      };
      const closeModal = () => {
        setModalIsOpen(false);
      };

    const GetUser  = async() =>{
        try{
          setIsLoading(true);
          const LabID = sessionStorage.getItem('LabID');
          const result  = await GetUser_ForDashboard(LabID)
          SetuserDetails(result)
        }catch(error){
         toast.error("Unabled to get user data",error)
        }finally{
            setIsLoading(false);
        }
       
      }

      useEffect(() => {
        GetUser();
      }, []);

     //-------------------Pagination

const itemsPerPage = 10; // Number of items per page
const [currentPage, setCurrentPage] = useState(1); // Pages start from 1

// Calculate the range of items to display on the current page
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const limitedData = userDetails.slice(indexOfFirstItem, indexOfLastItem);
// Handle page change
const handlePageChange = (event, newPage) => {
  setCurrentPage(newPage);
};
//---------------------END---------
//----------------Edit user---------
const[formData,setformData] = useState({
  FirstName:'',
  LastName:'',
  Email :'',
  PhoneNumber:'',
  Password:'',
  user_Role:'',
  LaboratoryID : sessionStorage.getItem('LabID'),
});
const onchange = (e) =>{
  const {name,value} = e.target;
  setformData({
      ...formData,
      [name]:value,
  }) 
}
const Role = [
  {
    value: 'Admin',
    label: 'Admin',
  },
  {
    value: 'User',
    label: 'User',
  },
 
];

//-----------GET single user-----------

const getsingleuser = async (userID)  =>{
  const LabID =  sessionStorage.getItem('LabID');
  const repo = await GetSingleUser(LabID,userID);
  console.log("repo",repo)
  setformData({
    FirstName:repo.firstName || "",
  LastName:repo.lastName || '',
  Email : repo.email || '',
  PhoneNumber: repo.phoneNumber|| '',
  Password:repo.password ||'',
  user_Role:repo.user_Role || '',
  LaboratoryID : sessionStorage.getItem('LabID'),
  });
  setModalIsOpen(true);
}

  const onsubmit = async(e) =>{
    e.preventDefault();
    setIsLoading(true)
    try{
        const response = await  EditUser(formData)
        if(response){
            toast.success("Data saved successfully");
        }
    }
    catch(error){
        console.log(error)
    }
    finally{
        setIsLoading(false)
    }
   } 
//-------------------------------------------data table===============
  // Define columns for the data table
  const columns = [
    {
      name: "User Name",
      selector: (row) => row.firstName,
      cellExport: (row) => row.firstName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      cellExport: (row) => row.email,
      sortable: true,
    },
    {
      name: "Password",
      selector: (row) => row.password,
      cellExport: (row) => row.password,
      sortable: true,
    },
    {
      name: "Role",
      selector: (row) => row.user_Role,
      cellExport: (row) => row.user_Role,
      sortable: true,
    },
    {
      name: "Actions",
      button: true, // This column will be for action buttons
      cell: (row) => (
        <div>
           <Button type='button'  variant="contained"  className="common-button"onClick={() =>getsingleuser(row.userID)}>EDIT</Button>
        </div>
      ),
    },
  ];

  // Table Data with Extensions
  const tableData = {
    columns,
    data: userDetails,
  };
  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ccc', // Row border
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ccc', // Column border
        fontSize:'12px'
      },
    },
    headCells: {
      style: {
        borderTop:'1px solid #ccc',
        borderRight: '1px solid #ccc', // Column border in header
        backgroundColor: 'white',
      },
    },
  };
    return(<>
          {isLoading && <SpinnerModal isLoading={true} />}
         <div  className="container-fluid Container2">
          <div className='common-box-shadow common-bg-white common-br-3px Common-min-height'>
            <div className='UM-label'>
            <h5 className='common-FontWeight common-FontFamily'>User Management</h5>
            </div>

              <div>
                 <SignUp userId={UserID}/>
              </div>
              <DataTableExtensions  columns={tableData.columns}
                  data={tableData.data} export={true} print={true}   >
                <DataTable
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="80vh"
                  highlightOnHover
                  pointerOnHover
                  responsive
                  customStyles={customStyles}
                />
              </DataTableExtensions>
          </div>
          

         </div>
               <Dialog open={modalIsOpen} keepMounted onClose={closeModal}  TransitionComponent={Transition}>
                    <DialogTitle sx={{fontWeight:600,backgroundColor:'#2c6bd7',color:'white'}}>{"Edit User"}</DialogTitle>
                    <Divider></Divider>
                    <DialogContent>
                    <div className='container-fluid pt-1'>
       <form onSubmit={onsubmit}>
           <div className='row pt-1'>
                <div  className='col-4 mt-2'>
                   <label className='common-Labels'>First Name <span className='common-Asterisk'>*</span></label>
                          <input
                              className="form-control common-Input"
                              label='First Name'
                              id='FirstName'
                              name='FirstName'
                              value={formData.FirstName}
                              required
                              onChange={onchange} />
                  </div>
                  
                <div  className='col-4 mt-2'>
                       <label className='common-Labels'>Last tName <span className='common-Asterisk'>*</span></label>
                          <input
                              className="form-control common-Input"
                              label='Last tName'
                              id='LastName'
                              name='LastName'
                              value={formData.LastName}
                              required
                              onChange={onchange}/>
                  </div>
                
                <div  className='col-4 mt-2'>
                <label className='common-Labels'>Phone Number <span className='common-Asterisk'>*</span></label>
                          <input
                              className="form-control common-Input"
                               label='PhoneNumber'
                              id='PhoneNumber'
                              name="PhoneNumber"
                              value={formData.PhoneNumber}
                              required
                              onChange={onchange} />
                </div>
                <div  className='col-4 mt-2'>
                   <label className='common-Labels'>Email<span className='common-Asterisk'>*</span></label>
                          <input
                              className="form-control common-Input"
                               label='Email'
                              id='Email'
                              name='Email'
                              value={formData.Email}
                              required
                              onChange={onchange} />
                </div>
                <div  className='col-4 mt-2'>
                    <label className='common-Labels'>Password <span className='common-Asterisk'>*</span></label>
                          <input
                              className="form-control common-Input"
                              label='Password'
                              id='Password'
                              name='Password'
                              value={formData.Password}
                              onChange={onchange} />
                  </div>
                <div  className='col-4 mt-2'>
                     <label className='common-Labels'>User Role <span className='common-Asterisk'>*</span></label>
                      <select className="form-select  common-Input"
                            label='User Role'
                            id='user_Role'
                            name='user_Role'
                            required
                            onChange={onchange}
                            value={formData.user_Role}
                            >  
                            {Role.map((option) => (
                            <option key={option.value} value={option.value}>
                            {option.label}
                            </option>
                            ))}
                        </select>
                </div>
            </div>
               <div className='row pt-4 mb-2'>
                 <div  className='col-3'>
                     <Button type='submit'  variant="contained"  className="common-button">Save</Button>
                 </div>
               </div>
       </form>
   </div>
                    </DialogContent>
                </Dialog>
      </>)
  }

  export default   UserLists